import { MarkerHalf } from './landmarkPress';

export type LandmarkEmphasis =
    | 'focus'
    | 'counterpart'
    | 'resting'
    | 'background';

export interface LandmarkEmphasisInput {
    readonly pairId: string;
    readonly half: MarkerHalf;
    readonly focusedHalf: MarkerHalf;
    readonly draggingPairId: string | null;
}

export function landmarkEmphasis({
    pairId,
    half,
    focusedHalf,
    draggingPairId,
}: LandmarkEmphasisInput): LandmarkEmphasis {
    if (draggingPairId === null) {
        return 'resting';
    }
    if (pairId !== draggingPairId) {
        return 'background';
    }
    // A null half is the predicted counterpart marker.
    return half !== null && half === focusedHalf ? 'focus' : 'counterpart';
}

export function showsExpectedMarker(complete: boolean): boolean {
    return !complete;
}
